import {useEffect, useState, useRef, LegacyRef, useCallback} from 'react';
import { DanceItem } from './DanceItem';
import DanceItemComp from './DanceItemComp';
import  ReactPlayer from 'react-player';
import axios, {  } from 'axios';
import config from '../Config';
import { useNavigate, useParams } from 'react-router-dom';

type VideoComponentProps = {
    url:string,
    startTimeInSeconds:number
}


const VideoComponent = ({url, startTimeInSeconds}: VideoComponentProps) => {
  
  const playerRef = useRef<ReactPlayer>(null);
  const startTimeRef = useRef<number>(0);

  const isReady = useRef(false);
  
  const [videoIsFacebookReel, setVideoIsFacebookReel] = useState<boolean>(false);

  useEffect(() => {
        setVideoIsFacebookReel(url.toLowerCase().startsWith("https://www.facebook.com/reel/"));
      }, [url]);


  const onReady = useCallback(() => {
    if (playerRef.current ===null){
      return;
    }
    if (!isReady.current) {
      playerRef.current.seekTo(startTimeRef.current, 'seconds');
      isReady.current = true;
    }
  }, [isReady]);


  

    return(
        <>
            {url.length > 0  && !videoIsFacebookReel && <ReactPlayer className="" ref={playerRef} url={url} width="350px" height="280px" controls={true} onReady={onReady}/>}
            {url.length > 0  && videoIsFacebookReel && <iframe
            src={`https://www.facebook.com/plugins/video.php?height=476&href=${url}&show_text=false&width=267&t=0`}
            width="267"
            height="476"
            style={{ border: 'none', overflow: 'hidden' }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          />}
        </>
    );
}

export default VideoComponent;